(() => {
  const init = (root = document) => {
    root.querySelectorAll('[data-lw-hero]:not([data-lw-ready])').forEach((hero) => {
      hero.dataset.lwReady = 'true';
      const slides = Array.from(hero.querySelectorAll('[data-lw-hero-slide]'));
      if (!slides.length) return;

      const previous = hero.querySelector('[data-lw-hero-prev]');
      const next = hero.querySelector('[data-lw-hero-next]');
      const counter = hero.querySelector('[data-lw-hero-current]');
      const status = hero.querySelector('[data-lw-hero-status]');
      const videoToggle = hero.querySelector('[data-lw-hero-video-toggle]');
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      const mobile = window.matchMedia('(max-width: 740px)');
      const autoplay = hero.dataset.lwHeroAutoplay === 'true';
      const interval = Math.max(4000, Number(hero.dataset.lwHeroInterval) || 7000);
      let active = 0;
      let timer;
      let inView = false;
      let hovered = false;
      let focused = false;
      let userPausedVideo = false;

      const activeVideo = () => slides[active]?.querySelector('[data-lw-hero-video]');
      const hasMatchingSource = (video) => Array.from(video.querySelectorAll('source')).some(
        (source) => !source.media || window.matchMedia(source.media).matches
      );

      const syncVideo = () => {
        slides.forEach((slide, index) => {
          if (index !== active) {
            const video = slide.querySelector('[data-lw-hero-video]');
            video?.pause();
            video?.classList.remove('is-playing');
          }
        });

        const video = activeVideo();
        const available = Boolean(video && !reducedMotion.matches && hasMatchingSource(video));
        if (videoToggle) {
          videoToggle.hidden = !available;
          videoToggle.textContent = userPausedVideo ? 'Play video' : 'Pause video';
          videoToggle.setAttribute('aria-label', userPausedVideo ? 'Play background video' : 'Pause background video');
        }
        if (!available || document.hidden || !inView || userPausedVideo) {
          video?.pause();
          video?.classList.remove('is-playing');
          return;
        }
        const playRequest = video.play();
        if (playRequest?.catch) playRequest.catch(() => video.classList.remove('is-playing'));
      };

      const schedule = () => {
        window.clearTimeout(timer);
        if (slides.length < 2 || !autoplay || reducedMotion.matches || document.hidden || !inView || hovered || focused || window.Shopify?.designMode) return;
        timer = window.setTimeout(() => show((active + 1) % slides.length), interval);
      };

      const show = (index, manual = false) => {
        active = (index + slides.length) % slides.length;
        userPausedVideo = false;
        slides.forEach((slide, slideIndex) => {
          const selected = slideIndex === active;
          slide.classList.toggle('is-active', selected);
          slide.inert = !selected;
          slide.setAttribute('aria-hidden', String(!selected));
        });
        const upcomingImage = slides[(active + 1) % slides.length]?.querySelector('img[loading="lazy"]');
        if (upcomingImage) upcomingImage.loading = 'eager';
        if (counter) counter.textContent = String(active + 1).padStart(2, '0');
        if (manual && status) status.textContent = `Banner ${active + 1} of ${slides.length}`;
        syncVideo();
        schedule();
      };

      previous?.addEventListener('click', () => show(active - 1, true));
      next?.addEventListener('click', () => show(active + 1, true));
      videoToggle?.addEventListener('click', () => {
        userPausedVideo = !userPausedVideo;
        syncVideo();
      });
      hero.addEventListener('mouseenter', () => { hovered = true; schedule(); });
      hero.addEventListener('mouseleave', () => { hovered = false; schedule(); });
      hero.addEventListener('focusin', () => { focused = true; schedule(); });
      hero.addEventListener('focusout', () => {
        window.setTimeout(() => { focused = hero.contains(document.activeElement); schedule(); }, 0);
      });
      document.addEventListener('visibilitychange', () => { syncVideo(); schedule(); });
      reducedMotion.addEventListener('change', () => { syncVideo(); schedule(); });
      mobile.addEventListener('change', () => {
        slides.forEach((slide) => {
          const video = slide.querySelector('[data-lw-hero-video]');
          if (video) { video.pause(); video.classList.remove('is-playing'); video.load(); }
        });
        syncVideo();
      });
      slides.forEach((slide) => {
        const video = slide.querySelector('[data-lw-hero-video]');
        video?.addEventListener('playing', () => video.classList.add('is-playing'));
        video?.addEventListener('pause', () => video.classList.remove('is-playing'));
        video?.addEventListener('error', () => video.classList.remove('is-playing'));
      });
      hero.addEventListener('shopify:block:select', (event) => {
        const selected = event.target.closest('[data-lw-hero-slide]');
        const index = slides.indexOf(selected);
        if (index !== -1) show(index, true);
      });

      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver((entries) => {
          inView = entries[0]?.isIntersecting ?? false;
          syncVideo();
          schedule();
        }, { threshold: 0.1 });
        observer.observe(hero);
      } else {
        inView = true;
      }
      show(0);
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  else init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
